import { createConfirmation } from "react-confirm";
import MessageDetailModal from "./MessageDetailModal";

export const showMessageDetailModal = createConfirmation(MessageDetailModal);
